import moment from "moment";
import momentTimeZone from "moment-timezone";
export default {
  formatTime(s) {
    moment.locale("en");
    if (s) {
      return moment(s).format("YYYY-MM-DD ddd HH:mm");
    } else {
      return "";
    }
  },
  formatYYMMDD(s) {
    moment.locale("en");
    if (s) {
      return moment(s).format("YYYY-MM-DD");
    } else {
      return "";
    }
  },
  formatLocalTimeYYYYMMDDHHmmss(s, timeZone) {
    if (s) {
      return momentTimeZone
        .tz(s, "Asia/Shanghai")
        .tz(timeZone)
        .format("YYYY-MM-DD HH:mm:ss");
    } else {
      return "";
    }
  },
  formatLocalTimeYYYYMMDDdddHHmm(s, timeZone) {
    if (s) {
      return momentTimeZone
        .tz(s, "Asia/Shanghai")
        .tz(timeZone)
        .format("YYYY-MM-DD ddd HH:mm");
    } else {
      return "";
    }
  },
  formatCNTimeYYYYMMDDdddHHmm(s, timeZone) {
    moment.locale('zh-cn');
    if (s) {
      return momentTimeZone
        .tz(s, "Asia/Shanghai")
        .tz(timeZone)
        .format("YYYY-MM-DD ddd HH:mm");
    } else {
      return "";
    }
  },
  formatENTimeMMDDddd(s, timeZone) {
    moment.locale("en");
    if (s) {
      return momentTimeZone
        .tz(s, "Asia/Shanghai")
        .tz(timeZone)
        .format("MM.DD ddd");
    } else {
      return "";
    }
  },
  formatCNTimeMMDDddd(s, timeZone) {
    moment.locale('zh-cn');
    if (s) {
      return momentTimeZone
        .tz(s, "Asia/Shanghai")
        .tz(timeZone)
        .format("MM.DD ddd");
    } else {
      return "";
    }
  },
  formatLocalTimeYYYYMMDD(s, timeZone) {
    if (s) {
      return momentTimeZone
        .tz(s, "Asia/Shanghai")
        .tz(timeZone)
        .format("YYYY-MM-DD");
    } else {
      return "";
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/tools.js